var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import Multiselect from "vue-multiselect";
import { LockUnlockActionEnum, UsersClient, LockUnlockUsersModel, RoleTypeEnum, GetUserListQuery, LockUnlockUsersCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { LoginState } from "@/app/store/modules/login.state";
import { State } from "vuex-facing-decorator";
const usersClient = new UsersClient(window.apiUrl);
let LockUnlockUsersModal = class LockUnlockUsersModal extends Vue {
    constructor() {
        super(...arguments);
        this.show = false;
        this.selectedCompany = null;
        this.selectedAction = LockUnlockActionEnum.Lock;
        this.actionOptions = [
            { value: LockUnlockActionEnum.Lock, text: "Lock" },
            { value: LockUnlockActionEnum.Unlock, text: "Unlock" }
        ];
        this.allUsers = [];
        this.selectedUserIds = [];
        this.showOnlySelected = false;
        this.usersFilter = "";
        this.validRoleIds = [RoleTypeEnum.Client, RoleTypeEnum.ClientAdministrator, RoleTypeEnum.ClientInstaller];
    }
    showModal() {
        this.show = true;
        try {
            this.fetchUsers();
            this.selectedCompany = this.companies[0];
            this.selectedAction = LockUnlockActionEnum.Lock;
            this.selectedUserIds = [];
            this.usersFilter = "";
            this.showOnlySelected = false;
        }
        catch (ex) {
            console.error(ex);
        }
    }
    fetchUsers() {
        var _a, _b;
        let companyId = (_b = (_a = this.selectedCompany) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null;
        usersClient.getListPOST(new GetUserListQuery({ companyId: companyId }))
            .then(users => {
            this.allUsers = (users || []).filter(user => this.validRoleIds.includes(user.roleId));
        });
    }
    onCompanyChanged() {
        this.selectedUserIds = [];
        this.fetchUsers();
    }
    onActionChanged() {
        this.selectedUserIds = [];
    }
    get filteredUsers() {
        var userId = this.loginState.userId;
        let users = this.allUsers.filter(u => u.userId != userId);
        // Filter by action: Lock/Unlock
        if (this.selectedAction === LockUnlockActionEnum.Lock) {
            users = users.filter(u => u.whenLockout == null);
        }
        else if (this.selectedAction === LockUnlockActionEnum.Unlock) {
            users = users.filter(u => u.whenLockout != null);
        }
        if (this.usersFilter) {
            const f = this.usersFilter.toLowerCase();
            users = users.filter(u => (u.userName && u.userName.toLowerCase().includes(f)) ||
                (u.firstName && u.firstName.toLowerCase().includes(f)) ||
                (u.lastName && u.lastName.toLowerCase().includes(f)) ||
                (u.emailAddress && u.emailAddress.toLowerCase().includes(f)));
        }
        if (this.showOnlySelected) {
            users = users.filter(u => this.selectedUserIds.includes(u.userId));
        }
        return users;
    }
    isUserSelected(user) {
        return this.selectedUserIds.includes(user.userId);
    }
    toggleUser(user) {
        const idx = this.selectedUserIds.indexOf(user.userId);
        if (idx >= 0)
            this.selectedUserIds.splice(idx, 1);
        else
            this.selectedUserIds.push(user.userId);
    }
    submit() {
        // Validation
        if (this.selectedAction === null || this.selectedAction === undefined) {
            Notifier.onWarning("Please select an action.");
            return;
        }
        if (!this.selectedUserIds.length) {
            Notifier.onWarning("Please select at least one user.");
            return;
        }
        var model = new LockUnlockUsersModel({
            userIds: this.selectedUserIds,
            action: this.selectedAction
        });
        const payload = new LockUnlockUsersCommand({ requestModel: model });
        usersClient.lockUnlockUsers(payload)
            .then(() => {
            Notifier.onOk("Users have been successfully updated.");
            this.$emit("usersUpdated");
            this.show = false;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    cancel() {
        this.show = false;
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], LockUnlockUsersModal.prototype, "companies", void 0);
__decorate([
    Prop({ default: "Lock/Unlock Users" }),
    __metadata("design:type", String)
], LockUnlockUsersModal.prototype, "modalTitle", void 0);
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_b = typeof LoginState !== "undefined" && LoginState) === "function" ? _b : Object)
], LockUnlockUsersModal.prototype, "loginState", void 0);
__decorate([
    Watch("selectedCompany"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LockUnlockUsersModal.prototype, "onCompanyChanged", null);
__decorate([
    Watch("selectedAction"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LockUnlockUsersModal.prototype, "onActionChanged", null);
LockUnlockUsersModal = __decorate([
    Component({
        components: { Multiselect },
        expose: ["showModal"],
        emits: ["usersUpdated"]
    })
], LockUnlockUsersModal);
export default LockUnlockUsersModal;
